import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {debounceTime} from "rxjs/operators";
import {isEmpty, isNotNil, toBoolean} from "../core/convert";

@Component({
  selector: 'jd-spin',
  template: `
    <ng-template #defaultIndicatorTemplate>
  <span
    class="ant-spin-dot"
    [class.ant-spin-dot-spin]="resultSpinning$|async">
    <i></i><i></i><i></i><i></i>
  </span>
    </ng-template>
    <div #nestedElement>
      <div [hidden]="!(resultSpinning$|async)">
        <div
          class="ant-spin"
          [class.ant-spin-spinning]="resultSpinning$|async"
          [class.ant-spin-lg]="jdSize=='large'"
          [class.ant-spin-sm]="jdSize=='small'"
          [class.ant-spin-show-text]="jdTip">
          <ng-template [ngTemplateOutlet]="jdIndicator||defaultIndicatorTemplate"></ng-template>
          <div class="ant-spin-text" *ngIf="jdTip">{{ jdTip }}</div>
        </div>
      </div>
      <div
        #containerElement
        class="ant-spin-container"
        [class.ant-spin-blur]="resultSpinning$|async"
        (cdkObserveContent)="checkNested()">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: []
})
export class JdSpinComponent implements AfterViewInit {
  private _tip: string;
  private _delay = 0;
  el: HTMLElement = this.elementRef.nativeElement;

  baseSpinning$ = new BehaviorSubject(true);
  resultSpinning$: Observable<boolean> = this.baseSpinning$.asObservable().pipe(debounceTime(this.jdDelay));
  @ViewChild('containerElement') containerElement: ElementRef;
  @ViewChild('nestedElement') nestedElement: ElementRef;
  @Input() jdIndicator: TemplateRef<void>;
  @Input() jdSize = 'default';

  @Input()
  set jdDelay(value: number) {
    if (isNotNil(value)) {
      this._delay = value;
      this.resultSpinning$ = this.baseSpinning$.asObservable().pipe(debounceTime(this.jdDelay));
    }
  }

  get jdDelay(): number {
    return this._delay;
  }

  @Input()
  set jdTip(value: string) {
    this._tip = value;
  }

  get jdTip(): string {
    return this._tip;
  }

  @Input()
  set jdSpinning(value: boolean) {
    this.baseSpinning$.next(toBoolean(value));
  }

  checkNested(): void {
    const containerElement = this.containerElement.nativeElement;
    const nestedElement = this.nestedElement.nativeElement;
    if (!isEmpty(containerElement)) {
      this.renderer.removeStyle(containerElement, 'display');
      this.renderer.setStyle(this.el, 'display', 'block');
      this.renderer.addClass(nestedElement, 'ant-spin-nested-loading');
    } else {
      this.renderer.setStyle(containerElement, 'display', 'none');
      this.renderer.removeStyle(this.el, 'display');
      this.renderer.removeClass(nestedElement, 'ant-spin-nested-loading');
    }
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    this.checkNested();
  }

}
